import React, { useContext, useEffect, useState } from 'react';
import { UserContext } from '../../utils/context/UserContext';
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Typography,
  message,
} from 'antd';
import {
  ERROR_NOTIFICATION_TYPE,
  SUCCESS_NOTIFICATION_TYPE,
  getAPIResponseMessage,
} from '../../utils/api/_ConstantsAPI';
import { Content } from 'antd/es/layout/layout';
import { IoIosRefresh } from 'react-icons/io';
import { AiOutlinePlus } from 'react-icons/ai';
import OutletDefaultType from '../../utils/types/OutletDefaultType';
import { addOutlet,updateOutlet,deleteOutlet, getOutletList } from '../../utils/api/OutletAPI';
import { getOutletsTable } from '../../utils/tableData/Maintenance/OutletsTable';
import { GlobalContext } from '../../App';
import Search from 'antd/es/input/Search';
import { getOutletMaintenanceFields } from '../../utils/data/OutletField';
import { FormInput } from '../../components';


export default function OutletMaintenance() {
  const { profile, formItemLayout } = useContext(UserContext);
  const { openNotification } = useContext(GlobalContext);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [outletState, setOutletState] = useState(OutletDefaultType);
  const [tableHeaderFilter, setTableHeaderFilter] = useState('');
  const [tableFilter, setTableFilter] = useState('');
  const [localOutletList, setLocalOutletList] = useState([]);

  const [form] = Form.useForm();


  const tableContents = localOutletList
  .filter((data) => {
    if (tableHeaderFilter === '') {
      return data;
    }
    return data[tableHeaderFilter]
      .toString()
      .toLowerCase()
      .includes(tableFilter.toLowerCase());
  })
  .map((data, index) => ({
    ...data,
    key: index,
  }));


  const handleAction = async (id, action) => {
    setIsLoading(true);
    if (action === 'edit') {
      const outlet = localOutletList.find((outs) => outs.id === id);
      setOutletState({ ...outlet });
      form.setFieldsValue(outlet);
      setIsModalOpen(true);
    } else if (action === 'delete') {
      const res = await deleteOutlet(profile.id,{
        id: id,
      });
      if (res.isSuccessful) {
        openNotification(
          SUCCESS_NOTIFICATION_TYPE,
          'Outlet',
          'Outlet successfully deleted.'
        );
        fetchOutletList();
      } else {
        openNotification(
          ERROR_NOTIFICATION_TYPE,
          'Outlet',
          'There was a problem deleting the outlet.'
        );
      }
    }
    setIsLoading(false);
  };

  const handleModalSave = async () => {
    setIsLoading(true);
    try {
      await form.validateFields();

      if(outletState.id == ''){
        const res = await addOutlet(profile.id, outletState);
        if (res.isSuccessful) {
          setIsModalOpen(false);
          openNotification(
            SUCCESS_NOTIFICATION_TYPE,
            'Outlet maintenance',
            getAPIResponseMessage(res.data)
          );
          fetchOutletList();
        } else {
          openNotification(
            ERROR_NOTIFICATION_TYPE,
            'Outlet maintenance',
            getAPIResponseMessage(res.data)
          );
        }
      }else{

        const res = await updateOutlet(profile.id, outletState);
        if (res.isSuccessful) {
          setIsModalOpen(false);
          openNotification(
            SUCCESS_NOTIFICATION_TYPE,
            'Outlet maintenance',
            getAPIResponseMessage(res.data)
          );
          fetchOutletList();
        } else {
          openNotification(
            ERROR_NOTIFICATION_TYPE,
            'Outlet maintenance',
            getAPIResponseMessage(res.data)
          );
        }
      }

   
    } catch (error) {
      // No action for now
    }
    setIsLoading(false);
  };

  const fetchOutletList = async () => {
    setIsLoading(true);
    resetData();

    const res = await getOutletList();
    console.log(res);
    if (res.isSuccessful) {
      setLocalOutletList(res.data);
    } else {
      openNotification(
        ERROR_NOTIFICATION_TYPE,
        'Outlet maintenance',
        getAPIResponseMessage(res.data)
      );
    }
    setIsLoading(false);
  };


  const resetData = () => {
    setTableHeaderFilter('');
    setTableFilter('');
    setOutletState(OutletDefaultType);
    form.setFieldsValue(OutletDefaultType);
  };

  useEffect(() => {
    if (localOutletList.length === 0) {
      fetchOutletList();
    }
  }, []);


  useEffect(() => {
    const fetchDataInterval = setInterval(() => {
      fetchOutletList();
    }, 1800000);

    return () => {
      clearInterval(fetchDataInterval);
    };
  }, []);


  return (
    <Content>
    <Row align={'middle'} className="mb-4">
      <Col xs={24} md={12}>
        <Typography.Title level={3}>Outlet Maintenance</Typography.Title>
      </Col>
      <Col xs={24} md={12} className="text-end">
        <Button
          type="primary"
          size="large"
          icon={<IoIosRefresh size={24} />}
          loading={isLoading}
          onClick={() => fetchOutletList()}
        />
        <Button
          type="primary"
          size="large"
          icon={<AiOutlinePlus size={24} />}
          loading={isLoading}
          className="ms-3"
          onClick={async () => {
            resetData();
            setIsModalOpen(true);
          }}
        />
      </Col>
    </Row>
    <Row className="mb-4">
      <Space.Compact>
        <Select
          style={{ minWidth: '10vw' }}
          placeholder="Filters"
          value={tableHeaderFilter}
          onChange={(e) => {
            setTableHeaderFilter(e);
          }}
          disabled={isLoading}
          options={getOutletsTable(null)
            .filter((header) => header.key !== 'actions')
            .map((option) => ({
              label: option.title,
              value: option.key,
            }))}
        />
        <Search
          placeholder="Search for outlet"
          disabled={isLoading || tableHeaderFilter === ''}
          value={tableFilter}
          onSearch={(value) => {
            setTableFilter(value);
          }}
          onChange={(e) => {
            const searchValue = e.target.value;
            setTableFilter(searchValue);
          }}
          allowClear={true}
        />
      </Space.Compact>
    </Row>
    <Table
      columns={getOutletsTable(handleAction)}
      dataSource={tableContents}
      size="small"
      bordered="true"
      scroll={{ x: true }}
      loading={isLoading}
    />
    <Modal
      title="Outlet Entry"
      centered
      closable={false}
      maskClosable={false}
      open={isModalOpen}
      onOk={handleModalSave}
      okText="Save"
      confirmLoading={isLoading}
      onCancel={() => setIsModalOpen(false)}
    >
      <Form
        form={form}
        name="outlet_form"
        {...formItemLayout}
        initialValues={outletState}
      >
        {getOutletMaintenanceFields(
          isLoading,
          outletState,
          setOutletState
        ).map((data, index) => (
          <FormInput
            key={index}
            type={data.type}
            name={data.name}
            placeholder={data.placeholder}
            label={data.label}
            autoFocus={data.autofocus}
            value={data.value}
            onChange={data.setValue}
            required={data.required}
            disabled={data.disabled}
            dropdownOptions={data.dropdownOptions}
          />
        ))}
      </Form>
    </Modal>
  </Content>
  )
}
